import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BsPeople, BsPerson, BsCheck2Circle, BsDisplay, BsQuestion, BsFolder, BsGear } from 'react-icons/bs';
import { Table, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { FaCheck, FaTimes, FaTrash, FaSortAmountUp, FaSortAmountDown, FaEdit, FaEllipsisV, FaTools, FaArrowRight, FaArrowLeft, FaPercent, FaGraduationCap, FaEye, FaMedal, FaChevronDown, FaFileExport, FaExclamationCircle, FaCertificate, FaAdjust } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import axios from 'axios';
import useAuth from '../../dashboard/useAuth';
import ModalProfilUtilisateur from '../../dashboard/ModalProfilUtilisateur';
import Select from 'react-select';

const Liste_utilisateur = ({ titre }) => {
    useAuth();
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [filtreAcces, setFiltreAcces] = useState('');
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingActivate, setIsLoadingActivate] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [showModalProfil, setShowModalProfil] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = utilisateurs.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const [selectedUser, setSelectedUser] = useState(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const [showExportModal, setShowExportModal] = useState(false);
    const [isLoadingExport, setIsLoadingExport] = useState(false);
    const [exportOption, setExportOption] = useState('tout');

    const handleExportClick = () => {
        setShowExportModal(true);
    };

    const handleExportConfirm = async (exportOption) => {
        setIsLoadingExport(true);
        try {
            const token = localStorage.getItem('access_token');

            // Construire l'URL avec les paramètres
            const url = new URL(`${process.env.REACT_APP_HOTE}/export-utilisateurs-excel/`);
            url.searchParams.append('export_type', exportOption);
            url.searchParams.append('search_term', searchTerm);
            url.searchParams.append('sort_key', sortConfig.key);
            url.searchParams.append('sort_direction', sortConfig.direction);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            // Récupérer le blob de la réponse
            const blob = await response.blob();

            const filename = exportOption === 'tel'
                ? `Numéros_telephone_eTrainApp.xlsx`
                : `Liste_utilisateur_eTrainApp.xlsx`;

            // Créer l'URL du blob et déclencher le téléchargement
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();

            // Nettoyer l'URL du blob
            window.URL.revokeObjectURL(downloadUrl);

            showAlert(`Export ${exportOption === 'tel' ? 'des téléphones' : 'excel'} généré avec succès`);
            setShowExportModal(false);
        } catch (error) {
            console.error('Export error:', error);
            showAlert('Erreur lors de l\'export', 'danger');
        } finally {
            setIsLoadingExport(false);
        }
    };



    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Liste des utilisateur"; // Définit le titre de la page
        }
    }, [user_id]);


    const fetchUtilisateurs = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs-complet/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            // IMPORTANT: Il faut appeler response.json() pour obtenir les données
            const data = await response.json();

            console.log("Données reçues:", data); // Pour déboguer

            // Vérifier si les données sont un tableau ou un objet avec une propriété 'utilisateurs'
            if (Array.isArray(data)) {
                setUtilisateurs(data);
                setFilteredUsers(data);
            } else if (data && data.utilisateurs) {
                // Si l'API retourne un objet avec une propriété 'utilisateurs'
                setUtilisateurs(data.utilisateurs);
                setFilteredUsers(data.utilisateurs);
            } else {
                console.error("Format de données inattendu:", data);
                setUtilisateurs([]);
                setFilteredUsers([]);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
            setUtilisateurs([]);
            setFilteredUsers([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {

        fetchUtilisateurs();
    }, []);

    const handleProfilUpdate = (updatedData) => {
        console.log('Profil mis à jour:', updatedData);
        // Faites quelque chose avec les données mises à jour si nécessaire
    };

    // Utiliser useEffect pour afficher le message après l'actualisation
    useEffect(() => {
        const successMessage = localStorage.getItem('successMessage');
        if (successMessage) {
            // Afficher le message
            setMessage(successMessage);

            // Effacer le message du localStorage après 7 secondes
            setTimeout(() => {
                setShowMessage(false);
                localStorage.removeItem('successMessage');
            }, 7000);
        }
    }, []); // Exécuter une seule fois lors du chargement de la page


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const sortedUsers = [...filteredUsers].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    // Pagination logic
    const indexOfLastUser = currentPage * itemsPerPage;
    const indexOfFirstUser = indexOfLastUser - itemsPerPage;
    const currentUsers = sortedUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(sortedUsers.length / itemsPerPage);

    // Remplacer votre handleFiltreAcces actuel par ceci :
    const handleFiltreAcces = (valeur) => {
        // Si on clique sur le même filtre, on le désactive
        console.log(valeur)
        const newFilter = valeur === filtreAcces ? '' : valeur;
        setFiltreAcces(newFilter);
        setCurrentPage(1); // Toujours revenir à la première page quand on change de filtre
    };

    // Et modifier votre useEffect de filtrage comme ceci :
    useEffect(() => {
        const results = utilisateurs.filter(user =>
            (user.nom || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.prenoms || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.statut || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.tel || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.profession || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.formation || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.date_insc || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.pourcentage_partenariat || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.attestation || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.certification || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.a_des_acces || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.diplome || '').toLowerCase().includes(searchTerm.toLowerCase())
        ).filter(user => {
            // Filtre par accès (si filtreAcces n'est pas vide)
            return filtreAcces ?
                (user.a_des_acces || '').toLowerCase() === filtreAcces.toLowerCase()
                : true;
        });

        setFilteredUsers(results);
    }, [searchTerm, utilisateurs, filtreAcces]);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // const handleUserSelect = (user, event) => {
    //     // Empêcher la propagation si on clique sur la checkbox
    //     if (event && event.target.type === 'checkbox') {
    //         return;
    //     }

    //     // Si on maintient Shift, on sélectionne une plage
    //     if (event && event.shiftKey && selectedUserIds.length > 0) {
    //         const currentIndex = currentUsers.findIndex(u => u.id === user.id);
    //         const lastSelectedId = selectedUserIds[selectedUserIds.length - 1];
    //         const lastSelectedIndex = currentUsers.findIndex(u => u.id === lastSelectedId);

    //         const start = Math.min(currentIndex, lastSelectedIndex);
    //         const end = Math.max(currentIndex, lastSelectedIndex);

    //         const rangeIds = currentUsers.slice(start, end + 1).map(u => u.id);
    //         setSelectedUserIds(prev => {
    //             const newSelection = [...prev];
    //             rangeIds.forEach(id => {
    //                 if (!newSelection.includes(id)) {
    //                     newSelection.push(id);
    //                 }
    //             });
    //             return newSelection;
    //         });
    //     }
    //     // Clic normal : ajoute ou retire de la sélection
    //     else {
    //         setSelectedUserIds(prev =>
    //             prev.includes(user.id)
    //                 ? prev.filter(id => id !== user.id)
    //                 : [...prev, user.id]
    //         );
    //         setSelectedUser(user);
    //     }
    // };


    const handleUserSelect = (user, event) => {
        // Empêcher la propagation si on clique sur la checkbox
        if (event && event.target.type === 'checkbox') {
            return;
        }

        // Si on maintient Shift, on sélectionne une plage
        if (event && event.shiftKey && selectedUserIds.length > 0) {
            const currentIndex = currentUsers.findIndex(u => u.id === user.id);
            const lastSelectedId = selectedUserIds[selectedUserIds.length - 1];
            const lastSelectedIndex = currentUsers.findIndex(u => u.id === lastSelectedId);

            const start = Math.min(currentIndex, lastSelectedIndex);
            const end = Math.max(currentIndex, lastSelectedIndex);

            const rangeIds = currentUsers.slice(start, end + 1).map(u => u.id);
            setSelectedUserIds(prev => {
                const newSelection = [...prev];
                rangeIds.forEach(id => {
                    if (!newSelection.includes(id)) {
                        newSelection.push(id);
                    }
                });
                return newSelection;
            });
        }
        // Clic normal : ajoute ou retire de la sélection
        else {
            const newSelectedIds = selectedUserIds.includes(user.id)
                ? selectedUserIds.filter(id => id !== user.id)
                : [...selectedUserIds, user.id];

            setSelectedUserIds(newSelectedIds);

            // Mettre à jour selectedUser seulement si un seul utilisateur est sélectionné
            if (newSelectedIds.length === 1) {
                const selectedUser = currentUsers.find(u => u.id === newSelectedIds[0]);
                setSelectedUser(selectedUser);
            } else {
                setSelectedUser(null); // Réinitialiser si multiple ou aucun sélection
            }
        }
    };


    // const handleSelectAll = (e) => {
    //     if (e.target.checked) {
    //         // Sélectionner tous les utilisateurs de la page courante
    //         const allUserIds = currentUsers.map(user => user.id);
    //         setSelectedUserIds(allUserIds);
    //     } else {
    //         // Désélectionner tous les utilisateurs
    //         setSelectedUserIds([]);
    //     }
    // };


    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Sélectionner tous les utilisateurs de la page courante
            const allUserIds = currentUsers.map(user => user.id);
            setSelectedUserIds(allUserIds);
            setSelectedUser(null); // Réinitialiser car sélection multiple
        } else {
            // Désélectionner tous les utilisateurs
            setSelectedUserIds([]);
            setSelectedUser(null); // Réinitialiser
        }
    };

    // const handleActivateUser = async () => {
    //     await handleToggleStatus(selectedUser);
    // };


    const handleActivateUser = async () => {
        if (selectedUserIds.length === 0) {
            showAlert("Veuillez sélectionner au moins un utilisateur", "warning");
            return;
        }

        setIsLoadingActivate(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/activer-utilisateur/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    user_ids: selectedUserIds
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(data.message);
                // Réinitialiser la sélection
                setSelectedUserIds([]);
                setSelectedUser(null);
                // Recharger la liste
                fetchUtilisateurs();
            } else {
                showAlert(data.message || "Erreur lors de l'opération", "danger");
            }
        } catch (error) {
            console.error('Error:', error);
            showAlert("Erreur réseau", "danger");
        } finally {
            setIsLoadingActivate(false);
        }
    };

    const handleDeleteUser = () => {
        if (selectedUserIds.length === 0) {
            showAlert("Veuillez sélectionner au moins un utilisateur", "warning");
            return;
        }
        // Ouvrir le modal de confirmation
        setShowDeleteModal(true);
    };

    const deleteUser = async () => {
        setIsLoadingDelete(true);
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/supprimer-utilisateur/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        selectedUserIds: selectedUserIds, // tableau d'IDs
                        user_id: user_id,
                    }),
                }
            );

            const data = await response.json();

            // Vérifier si la requête est réussie
            if (response.ok) {
                showAlert(data.message);
                fetchUtilisateurs();
                // Réinitialiser la sélection
                setSelectedUserIds([]);
                setSelectedUser(null);
            } else {
                // En cas d'erreur du serveur (ex: utilisateur non trouvé)
                showAlert(`Erreur lors de la suppression des users`);
            }
        } catch (error) {
            // Gérer les erreurs éventuelles
            showAlert('Une erreur est survenue lors de la suppression.');
        } finally {
            setIsLoadingDelete(false);
        }
    };

    const confirmDeleteUser = async () => {
        setIsDeleting(true);
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/supprimer-utilisateur/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        selectedUserIds: selectedUserIds,
                        user_id: user_id,
                    }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                showAlert(data.message);
                fetchUtilisateurs();
                setSelectedUserIds([]);
                setSelectedUser(null);
                setShowDeleteModal(false);
            } else {
                showAlert(`Erreur lors de la suppression des users`);
            }
        } catch (error) {
            showAlert('Une erreur est survenue lors de la suppression.');
        } finally {
            setIsDeleting(false);
        }
    };


    const [showPourcentageModal, setShowPourcentageModal] = useState(false);
    const [pourcentage_partenariat, setPourcentage_partenariat] = useState();
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const handleOpenPourcentageModal = () => {
        setShowPourcentageModal(true);
    };

    const handleClosePourcentageModal = () => {
        setShowPourcentageModal(false);
    };


    const handleDefinirPourcentage = async (e) => {
        e.preventDefault();
        setIsLoadingButton(true);

        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${selectedUser.id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    pourcentage_partenariat: pourcentage_partenariat
                })
            });

            if (!response.ok) throw new Error('Erreur réseau');
            const result = await response.json();

            showAlert(`Pourcentage défini sur ${pourcentage_partenariat}%`);
            fetchUtilisateurs()

        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors de la modification');
        } finally {
            setIsLoadingButton(false);
            setShowPourcentageModal(false);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };



    // Fonctions pour l'import/export
    const [showImportModal, setShowImportModal] = useState(false);
    const [isImporting, setIsImporting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);


    const handleShowImportModal = () => setShowImportModal(true);
    const handleCloseImportModal = () => setShowImportModal(false);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handlefichier = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            showAlert("Veuillez sélectionner un fichier à importer.", "danger");
            return;
        }

        if (!selectedUser) {
            showAlert("Veuillez sélectionner un utilisateur.", "danger");
            return;
        }

        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
        const maxFileSize = 50 * 1024 * 1024;

        if (!allowedTypes.includes(selectedFile.type)) {
            showAlert("Type de fichier non supporté. Formats acceptés: PDF, JPEG, PNG", "danger");
            return;
        }

        if (selectedFile.size > maxFileSize) {
            showAlert("Le fichier est trop volumineux. La taille maximale autorisée est de 50 Mo.", "danger");
            return;
        }

        try {
            setIsImporting(true);
            showAlert("Importation en cours...", "info");

            const formData = new FormData();
            formData.append("fichier", selectedFile);

            const token = localStorage.getItem('access_token');

            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/importer-attestation/${selectedUser.id}/${user_id}/`,
                {
                    method: "POST",
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                }
            );

            const data = await response.json();
            if (response.ok) {
                showAlert(data.message, "success");
                fetchUtilisateurs();
                setSelectedUser(null);
                setSelectedUserIds([]);
            } else {
                // const errorMsg = errorData?.message || "Échec de l'importation. Veuillez réessayer.";
                showAlert(data.error, "danger");
            }
        } catch (error) {
            console.error("Erreur lors de l'importation:", error);
            showAlert("Erreur lors de l'importation", "danger");
        } finally {
            setIsImporting(false);
            setShowImportModal(false);
            setSelectedFile(null);
        }
    };



    const [previewFile, setPreviewFile] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const handlePrevisualisation = async () => {
        if (!selectedUser) {
            showAlert("Veuillez sélectionner un utilisateur", "danger");
            return;
        }

        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/previsualisation-attestation/${selectedUser.id}/${user_id}/`,
                {
                    method: 'GET',
                    headers: {
                        // 'Accept': 'application/pdf, image/*',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                let errorMessage = 'Erreur lors de la récupération du fichier';

                // Essayer de lire le message d'erreur JSON
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.error || errorData.message || errorMessage;
                } catch {
                    // Si ce n'est pas du JSON, utiliser le statut HTTP
                    if (response.status === 404) {
                        errorMessage = "Aucun fichier d'attestation trouvé pour cet utilisateur";
                    } else if (response.status === 401) {
                        errorMessage = "Non autorisé. Veuillez vous reconnecter.";
                    } else if (response.status === 403) {
                        errorMessage = "Accès interdit à ce fichier.";
                    } else {
                        errorMessage = `Erreur ${response.status}: ${response.statusText}`;
                    }
                }

                throw new Error(errorMessage);
            }

            const contentType = response.headers.get('content-type');
            const blob = await response.blob();

            // Vérifier que le blob n'est pas vide
            if (blob.size === 0) {
                throw new Error("Le fichier est vide");
            }

            // Créer une URL pour le blob
            const fileUrl = window.URL.createObjectURL(blob);

            // Déterminer le type de fichier
            let fileType = 'other';
            let fileExtension = 'file';

            if (contentType) {
                if (contentType.includes('pdf')) {
                    fileType = 'pdf';
                    fileExtension = 'pdf';
                } else if (contentType.includes('image')) {
                    fileType = 'image';
                    // Extraire l'extension (jpeg, png, etc.)
                    fileExtension = contentType.split('/')[1] || 'jpg';
                }
            }

            setPreviewFile({
                url: fileUrl,
                type: fileType,
                name: `${selectedUser.nom}_${selectedUser.prenoms}_attestation.${fileExtension}`
            });

            setShowPreviewModal(true);

        } catch (error) {
            console.error("Erreur de prévisualisation:", error);
            showAlert(error.message || "Impossible de prévisualiser le fichier", "danger");
        }
    };



    const [showCertificationModal, setShowCertificationModal] = useState(false);
    const [certificationStatut, setCertificationStatut] = useState('');
    const [estCertifier, setEstCertifier] = useState(false);

    const handleOuvrirCertifModal = () => {
        if (!selectedUser) return;
        setShowCertificationModal(true);
    };

    const handleFermerCertificationModal = () => {
        setShowCertificationModal(false);
        setCertificationStatut(null);
    };

    const handleCertifierUtilisateur = async () => {
        if (!selectedUser || certificationStatut === null) return;

        setEstCertifier(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${selectedUser.id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    certification: certificationStatut
                })
            });

            const data = await response.json();
            if (response.ok) {
                showAlert('Certification mis à jour');
                fetchUtilisateurs();
            } else {
                showAlert(data.error);
            }

        } catch (error) {
            console.error('Error certifying user:', error);
            showAlert('Erreur lors de la certification', 'danger');
        } finally {
            setEstCertifier(false);
            handleFermerCertificationModal();
        }
    };



    const [showClearDataModal, setShowClearDataModal] = useState(false);
    const [isClearingData, setIsClearingData] = useState(false);
    const [userToClear, setUserToClear] = useState(null);


    const handleClearUserData = async () => {
        if (!userToClear) return;

        setIsClearingData(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/vider-donnees-utilisateur/`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        user_id: userToClear.id,
                        gestionnaire_id: user_id,
                    }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                showAlert(
                    `Données de ${userToClear.nom} ${userToClear.prenoms} reset avec succès. ${data.details?.simulation_json?.simulations_conservees || 0} simulations journalières conservées.`,
                    'success'
                );
                fetchUtilisateurs();
            } else {
                showAlert(data.message || data.error || 'Erreur lors du reset des données', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur réseau lors du reset des données', 'danger');
        } finally {
            setIsClearingData(false);
            setShowClearDataModal(false);
            setUserToClear(null);
        }
    };

    // Fonction pour ouvrir le modal de confirmation
    const openClearDataModal = (user) => {
        setUserToClear(user);
        setShowClearDataModal(true);
    };



    const [showColumnSelector, setShowColumnSelector] = useState(false);

    const columnLabels = {
        nom_prenom: "Nom et prénom",
        Email: "Email",
        Email_pro: "Email professionnel",
        Telephone: "Telephone",
        Diplome: "Diplome",
        Profession: "Profession",
        type_financement: "Type de financement",
        nom_organisation: "Organisation",
        email_corporate: "Email corporate",
        Statut: "Statut",
        Inscription: "Inscription",
        Derniere_connexion: "Derniere_connexion",
        Attestation: "Attestation",
        Certification: "Certification",
        specialites: "Spécialités",
        a_des_acces: "Acces",
        // liste_acces: "lListe des acces",
    };

    const [visibleColumns, setVisibleColumns] = useState({
        nom_prenom: true,
        Email: true,
        Email_pro: false,
        Telephone: true,
        Diplome: true,
        Profession: false,
        Formation: true,
        type_financement: false,
        nom_organisation: false,
        email_corporate: false,
        Statut: true,
        Inscription: true,
        Derniere_connexion: true,
        Attestation: true,
        Certification: true,
        specialites: false,
        a_des_acces: true,
        liste_acces: true,
    });

    const [selectedUserIds, setSelectedUserIds] = useState([]);

    // const handleCheckboxChange = (id) => {
    //     setSelectedUserIds((prev) =>
    //         prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    //     );
    // };

    const handleCheckboxChange = (id) => {
        const newSelectedIds = selectedUserIds.includes(id)
            ? selectedUserIds.filter(item => item !== id)
            : [...selectedUserIds, id];

        setSelectedUserIds(newSelectedIds);

        // Mettre à jour selectedUser seulement si un seul utilisateur est sélectionné
        if (newSelectedIds.length === 1) {
            const selectedUser = currentUsers.find(u => u.id === newSelectedIds[0]);
            setSelectedUser(selectedUser);
        } else {
            setSelectedUser(null); // Réinitialiser si multiple ou aucun sélection
        }
    };





    const [showSpecialiteModal, setShowSpecialiteModal] = useState(false);
    const [specialites, setSpecialites] = useState([]);
    const [selectedSpecialites, setSelectedSpecialites] = useState([]);
    const [isLoadingSpecialites, setIsLoadingSpecialites] = useState(false);
    const [specialitePage, setSpecialitePage] = useState(1);
    const [specialiteSearch, setSpecialiteSearch] = useState('');
    const [totalSpecialites, setTotalSpecialites] = useState(0);
    const [isUpdatingSpecialites, setIsUpdatingSpecialites] = useState(false);



    const fetchSpecialites = async (page = 1, search = '') => {
        setIsLoadingSpecialites(true);
        try {
            const token = localStorage.getItem('access_token');
            const url = `${process.env.REACT_APP_HOTE}/liste-specialite/?page=${page}&per_page=10&search=${search}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                const data = await response.json();
                setSpecialites(data.liste_spe || []);
                setTotalSpecialites(data.total || 0);
            } else {
                console.error('Erreur lors de la récupération des spécialités');
                setSpecialites([]);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setSpecialites([]);
        } finally {
            setIsLoadingSpecialites(false);
        }
    };

    // Fonction pour ouvrir le modal d'assignation des spécialités
    const handleOpenSpecialiteModal = (user) => {
        setSelectedUser(user);
        // Récupérer les spécialités déjà assignées à l'utilisateur
        // Si les spécialités sont dans l'objet user, utilisez-les directement
        const userSpecialiteIds = user.specialites ? user.specialites.map(s => s.id) : [];
        setSelectedSpecialites(userSpecialiteIds);
        setSpecialitePage(1);
        setSpecialiteSearch('');
        fetchSpecialites(1, '');
        setShowSpecialiteModal(true);
    };

    // Fonction pour gérer la sélection/déselection des spécialités
    const handleSpecialiteToggle = (specialiteId) => {
        setSelectedSpecialites(prev =>
            prev.includes(specialiteId)
                ? prev.filter(id => id !== specialiteId)
                : [...prev, specialiteId]
        );
    };

    // Fonction pour sauvegarder les spécialités assignées
    const handleSaveSpecialites = async () => {
        if (!selectedUser) return;

        setIsUpdatingSpecialites(true);
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_HOTE}/gerer-specialites-utilisateur/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    gestionnaire_id: user_id,
                    user_id: selectedUser.id,
                    specialites: selectedSpecialites
                })
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(data.message, 'success');
                // Mettre à jour l'utilisateur dans la liste locale
                setUtilisateurs(prev => prev.map(u =>
                    u.id === selectedUser.id
                        ? { ...u, specialites: data.data.specialites }
                        : u
                ));
                setFilteredUsers(prev => prev.map(u =>
                    u.id === selectedUser.id
                        ? { ...u, specialites: data.data.specialites }
                        : u
                ));
                setShowSpecialiteModal(false);
            } else {
                showAlert(data.error || 'Erreur lors de l\'assignation', 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur réseau', 'danger');
        } finally {
            setIsUpdatingSpecialites(false);
        }
    };




    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Utilisateurs")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <h2>
                                        <BsPerson size={25} className='mr-2' />Gestion des Utilisateurs
                                        <span className="align-items-center badge bg-success ms-3 ml-2" style={{ fontSize: '13px', padding: '5px 10px' }}>
                                            <BsPerson size={12} className="mr-1" />
                                            {utilisateurs.filter(u => u.online === true).length} en ligne
                                        </span>
                                    </h2>
                                    <small>Administration des utilisateurs.</small>
                                </div>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <Link to={`/Liste-utilisateur`}> Utilisateurs</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">

                        {alert.message && (
                            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
                                <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                <span
                                    onClick={fermerNotif}
                                    style={{
                                        position: 'absolute',
                                        top: '0px',
                                        right: '10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <i className='fa fa-close'></i>
                                </span>
                            </div>
                        )}
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des utilisateurs</h5>
                                <div className="d-flex">
                                    {/* Bouton Activer/Désactiver */}
                                    <button
                                        onClick={handleActivateUser}
                                        disabled={selectedUserIds.length < 1 || isLoadingActivate}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedUserIds.length > 0 && !isLoadingActivate ? 'btn-success' : 'btn-default text-dark disabled'
                                            }`}
                                    >
                                        {isLoadingActivate ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                <span className="d-none d-sm-inline">
                                                    Chargement...
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <FaCheck />
                                                <span className="d-none d-sm-inline ml-2">
                                                    Activer / Désactiver {selectedUserIds.length > 0 && `(${selectedUserIds.length})`}
                                                </span>
                                            </>
                                        )}
                                    </button>

                                    {/* <button
                                        disabled={!selectedUser || selectedUserIds.length > 1}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 mr-2 ${selectedUser && selectedUserIds.length <= 1
                                            ? 'btn-success'
                                            : 'btn-default text-dark disabled'
                                            }`}
                                        onClick={() => setShowModalProfil(true)}
                                    >
                                        <FaCheck />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier
                                        </span>

                                        <ModalProfilUtilisateur
                                            show={showModalProfil}
                                            onHide={() => setShowModalProfil(false)}
                                            user_id={selectedUser?.id}
                                            onUpdate={handleProfilUpdate}
                                        />

                                    </button> */}

                                    {/* Bouton Supprimer */}
                                    <button
                                        onClick={handleDeleteUser}  // Cette fonction ouvre maintenant le modal
                                        disabled={selectedUserIds.length < 1 || isLoadingDelete}
                                        className={`btn d-flex align-items-center justify-content-center mr-2 ms-2 mt-1 ${selectedUserIds.length > 0 && !isLoadingDelete ? 'btn-success' : 'btn-default text-dark disabled'
                                            }`}
                                    >
                                        {isLoadingDelete ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                <span className="d-none d-sm-inline">
                                                    Chargement...
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <FaTrash />
                                                <span className="d-none d-sm-inline ml-2">
                                                    Supprimer {selectedUserIds.length > 0 && `(${selectedUserIds.length})`}
                                                </span>
                                            </>
                                        )}
                                    </button>

                                    {/* Bouton Attester - désactivé en sélection multiple */}
                                    {/* <button
                                        onClick={handleShowImportModal}
                                        disabled={!selectedUser || selectedUserIds.length > 1}
                                        className={`btn d-flex align-items-center justify-content-center mr-2 ms-2 mt-1 ${selectedUser && selectedUserIds.length <= 1 ? 'btn-success' : 'btn-default text-dark disabled'
                                            }`}
                                        title={selectedUserIds.length > 1 ? "Non disponible en sélection multiple" : ""}
                                    >
                                        <FaGraduationCap />
                                        <span className="d-none d-sm-inline ml-2">
                                            Attester
                                        </span>
                                    </button> */}

                                    {/* Bouton Visualiser - désactivé en sélection multiple */}
                                    {/* <button
                                        onClick={handlePrevisualisation}
                                        disabled={!selectedUser || selectedUser.attestation !== 'Oui' || selectedUserIds.length > 1}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 mr-2 ${selectedUser && selectedUser.attestation === 'Oui' && selectedUserIds.length <= 1
                                            ? 'btn-success'
                                            : 'btn-default text-dark disabled'
                                            }`}
                                        title={selectedUserIds.length > 1 ? "Non disponible en sélection multiple" : ""}
                                    >
                                        <FaEye />
                                        <span className="d-none d-sm-inline ml-2">
                                            Visualiser
                                        </span>
                                    </button> */}

                                    {/* Bouton Certifier - désactivé en sélection multiple */}
                                    {/* <button
                                        onClick={handleOuvrirCertifModal}
                                        disabled={!selectedUser || selectedUserIds.length > 1}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedUser && selectedUserIds.length <= 1 ? 'btn-success' : 'btn-default text-dark disabled'
                                            }`}
                                        title={selectedUserIds.length > 1 ? "Non disponible en sélection multiple" : ""}
                                    >
                                        <FaMedal />
                                        <span className="d-none d-sm-inline ml-2">
                                            Certifier
                                        </span>
                                    </button> */}

                                    <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1 py-0" onClick={handleExportClick} disabled={isLoadingExport}>
                                        <FaFileExport className="mr-2" />
                                        {!isLoadingExport ? 'Exporter' : 'En cours...'}
                                    </button>
                                </div>
                            </div>
                            <Modal show={showPourcentageModal} onHide={handleClosePourcentageModal}>
                                <Modal.Header>
                                    <Modal.Title>Définir pourcentage</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pourcentage partenariat</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max="100"
                                                value={pourcentage_partenariat}
                                                onChange={(e) => setPourcentage_partenariat(Math.max(1, parseInt(e.target.value) || 1))}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClosePourcentageModal}>
                                        Fermer
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleDefinirPourcentage}
                                        disabled={isLoadingButton}
                                    >
                                        {isLoadingButton ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            'Définir'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showImportModal} onHide={handleCloseImportModal}>
                                <Modal.Header>
                                    <Modal.Title>Importation de l'attestation</Modal.Title>
                                </Modal.Header>
                                <Form>
                                    <Modal.Body>
                                        <Form.Group controlId="formFile" className="mt-3">
                                            <Form.Label>Sélectionnez le fichier d'attestation</Form.Label>
                                            <Form.Control
                                                type="file"
                                                onChange={handleFileChange}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                required
                                            />
                                            {/* <Form.Text className="text-muted">
                                                Formats acceptés: PDF, JPG, PNG (max 50MB)
                                            </Form.Text> */}
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseImportModal}>
                                            Annuler
                                        </Button>
                                        <Button
                                            variant="success"
                                            type="submit"
                                            disabled={!selectedFile || isImporting}
                                            onClick={handlefichier}
                                        >
                                            {isImporting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ml-2">Importation...</span>
                                                </>
                                            ) : (
                                                'Importer'
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>



                            <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="lg" centered>
                                <Modal.Header>
                                    <Modal.Title>Prévisualisation de l'attestation de {selectedUser?.nom} {selectedUser?.prenoms} </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="text-center" style={{ minHeight: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {previewFile ? (
                                        <>
                                            {previewFile.type === 'pdf' ? (
                                                <iframe
                                                    src={previewFile.url}
                                                    title={previewFile.name}
                                                    style={{ width: '100%', height: '500px', border: 'none' }}
                                                />
                                            ) : previewFile.type === 'image' ? (
                                                <img
                                                    src={previewFile.url}
                                                    alt={previewFile.name}
                                                    style={{ maxWidth: '100%', maxHeight: '500px' }}
                                                />
                                            ) : (
                                                <div>
                                                    <p>Type de fichier non supporté pour la prévisualisation</p>
                                                    <a
                                                        href={previewFile.url}
                                                        download={previewFile.name}
                                                        className="btn btn-primary"
                                                    >
                                                        Télécharger le fichier
                                                    </a>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="text-muted">Chargement...</div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
                                        Fermer
                                    </Button>
                                    {previewFile && (
                                        <a
                                            href={previewFile.url}
                                            download={previewFile.name}
                                            className="btn btn-success"
                                        >
                                            {/* <FaDownload className="mr-2" /> */}
                                            Télécharger
                                        </a>
                                    )}
                                </Modal.Footer>
                            </Modal>




                            {/* Modal de certification */}
                            <Modal show={showCertificationModal} onHide={handleFermerCertificationModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmation de certification</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Voulez-vous certifier l'utilisateur {selectedUser?.nom} {selectedUser?.prenoms} ?</p>

                                    <div className="d-flex flex-column gap-3 mt-4">
                                        <Form.Check
                                            type="radio"
                                            id="certifier-oui"
                                            label="Oui"
                                            name="certificationChoice"
                                            checked={certificationStatut === 'Oui'}
                                            onChange={() => setCertificationStatut('Oui')}
                                            className="fs-5" // Taille de police augmentée
                                        />

                                        <Form.Check
                                            type="radio"
                                            id="certifier-non"
                                            label="Non"
                                            name="certificationChoice"
                                            checked={certificationStatut === 'Non'}
                                            onChange={() => setCertificationStatut('Non')}
                                            className="fs-5" // Taille de police augmentée
                                        />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleFermerCertificationModal}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleCertifierUtilisateur}
                                        disabled={certificationStatut === null || estCertifier}
                                    >
                                        {estCertifier ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            'Confirmer'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>



                            {/* Modal d'export */}
                            <Modal show={showExportModal} onHide={() => setShowExportModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Options d'export</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Check
                                            type="radio"
                                            id="export-tout"
                                            name="exportOption"
                                            label="Exporter toute la liste"
                                            checked={exportOption === 'tout'}
                                            onChange={() => setExportOption('tout')}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="export-tel"
                                            name="exportOption"
                                            label="Exporter uniquement les numéros de téléphone"
                                            checked={exportOption === 'tel'}
                                            onChange={() => setExportOption('tel')}
                                        />
                                    </Form>
                                    <small className="text-muted mt-2 d-block">
                                        Sélectionnez ce que vous souhaitez exporter
                                    </small>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowExportModal(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() => handleExportConfirm(exportOption)}
                                        disabled={isLoadingExport}
                                    >
                                        {!isLoadingExport ? 'Exporter' : 'En cours...'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                            {/* Modal d'assignation des spécialités */}


                            <Modal show={showSpecialiteModal} onHide={() => setShowSpecialiteModal(false)} size="lg">
                                <Modal.Header>
                                    <Modal.Title>
                                        {/* <FaCertificate className="mr-2" /> */}
                                        Gérer les spécialités de {selectedUser?.nom} {selectedUser?.prenoms}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Spécialités</Form.Label>
                                            <Select
                                                isMulti
                                                options={specialites.map(specialite => ({
                                                    value: specialite.id,
                                                    label: specialite.titre,
                                                    tags: specialite.tag || []
                                                }))}
                                                value={selectedSpecialites.map(id => {
                                                    const specialite = specialites.find(s => s.id === id);
                                                    return specialite ? {
                                                        value: specialite.id,
                                                        label: specialite.titre,
                                                        tags: specialite.tag || []
                                                    } : null;
                                                }).filter(Boolean)}
                                                onChange={(selectedOptions) => {
                                                    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                    setSelectedSpecialites(selectedIds);
                                                }}
                                                onInputChange={(inputValue, { action }) => {
                                                    if (action === 'input-change') {
                                                        setSpecialiteSearch(inputValue);
                                                        setSpecialitePage(1);
                                                        fetchSpecialites(1, inputValue);
                                                    }
                                                }}
                                                isLoading={isLoadingSpecialites}
                                                placeholder="Rechercher et sélectionner des spécialités..."
                                                noOptionsMessage={() =>
                                                    specialiteSearch ? 'Aucune spécialité trouvée' : 'Commencez à taper pour rechercher...'
                                                }
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '45px',
                                                        borderColor: '#e5e6e7',
                                                        '&:hover': {
                                                            borderColor: '#0d6efd'
                                                        }
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#0d6efd',
                                                        borderRadius: '4px'
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: 'white',
                                                        padding: '4px 8px'
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: 'white',
                                                        '&:hover': {
                                                            backgroundColor: '#0e7b5e',
                                                            color: 'white'
                                                        }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}
                                                formatOptionLabel={({ label, tags }) => (
                                                    <div className="d-flex justify-content-between align-items-center w-100">
                                                        <span>{label}</span>
                                                        {/* {tags && tags.length > 0 && (
                                                            <div className="ms-2">
                                                                {tags.slice(0, 2).map((tag, idx) => (
                                                                    <span key={idx} className="badge bg-secondary me-1" style={{ fontSize: '10px' }}>
                                                                        {tag}
                                                                    </span>
                                                                ))}
                                                                {tags.length > 2 && (
                                                                    <span className="badge bg-secondary" style={{ fontSize: '10px' }}>
                                                                        +{tags.length - 2}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )} */}
                                                    </div>
                                                )}
                                            />
                                            <Form.Text className="text-muted">
                                                Vous pouvez sélectionner plusieurs spécialités pour cet utilisateur
                                            </Form.Text>
                                        </Form.Group>
                                    </Form>

                                    {/* Indicateur de chargement pour la pagination infinie */}
                                    {isLoadingSpecialites && specialites.length === 0 && (
                                        <div className="text-center mt-3">
                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                {/* <span className="visually-hidden">Chargement...</span> */}
                                            </div>
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowSpecialiteModal(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleSaveSpecialites}
                                        disabled={isUpdatingSpecialites}
                                    >
                                        {isUpdatingSpecialites ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Enregistrement...
                                            </>
                                        ) : (
                                            'Enregistrer'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal de confirmation de suppression */}
                            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} >
                                <Modal.Header className=" text-black">
                                    <Modal.Title>
                                        Confirmation de suppression
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="text-center ">
                                        <FaExclamationCircle className="text-danger " size={48} />
                                        <h5 className="mt-3">Êtes-vous sûr de vouloir supprimer ces utilisateurs ?</h5>
                                        <p className="text-dark">
                                            <strong>{selectedUserIds.length}</strong> utilisateur{selectedUserIds.length > 1 ? 's' : ''} sélectionné{selectedUserIds.length > 1 ? 's' : ''}:
                                            
                                        </p>

                                        {/* Afficher la liste des utilisateurs à supprimer */}
                                        {selectedUserIds.length > 0 && selectedUserIds.length <= 5 && (
                                            <div className="mt-3 text-start">
                                                <ul className="list-unstyled mt-1">
                                                    {currentUsers
                                                        .filter(user => selectedUserIds.includes(user.id))
                                                        .map(user => (
                                                            <li key={user.id} className="py-1 border-bottom" color='#000' style={{color:"#000"}}>
                                                                
                                                                {user.nom} {user.prenoms} ({user.email})
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        )}

                                        {selectedUserIds.length > 5 && (
                                            <div className="mt-3 text-muted">
                                                <small>
                                                    {selectedUserIds.length} utilisateurs sélectionnés
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowDeleteModal(false)}
                                        disabled={isDeleting}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={confirmDeleteUser}
                                        disabled={isDeleting}
                                    >
                                        {isDeleting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Suppression en cours...
                                            </>
                                        ) : (
                                            <>
                                                <FaTrash className="mr-2" />
                                                Supprimer
                                            </>
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                            {/* Modal de confirmation pour vider les données utilisateur */}
                            <Modal show={showClearDataModal} onHide={() => setShowClearDataModal(false)} centered>
                                <Modal.Header>
                                    <Modal.Title>
                                        Reset les données utilisateur
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>

                                    <div className="alert alert-warning">
                                        <ul className="m-0">
                                            <li>Les données d'examen blanc et Essai seront <strong>complètement supprimées</strong></li>
                                            <li>Les simulations (hors QCM journaliers) seront <strong>supprimées</strong></li>
                                            <li>Les QCM journaliers (J1 à J30) seront <strong>conservés</strong></li>
                                            <li>Cette action est <strong>irréversible</strong></li>
                                        </ul>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowClearDataModal(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={handleClearUserData}
                                        disabled={isClearingData}
                                    >
                                        {isClearingData ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Reset en cours...
                                            </>
                                        ) : (
                                            <>
                                                <FaTrash className="mr-2" />
                                                Confirmer le reset
                                            </>
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="form-select bg-light p-1 mr-2" style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}>
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                    </select>
                                                    {/* <select
                                                        className="ml-2 form-select form-select-sm"
                                                        value={filtreAcces}
                                                        onChange={(e) => handleFiltreAcces(e.target.value)}
                                                    >
                                                        <option value="">Tous</option>
                                                        <option value="Oui">Oui</option>
                                                        <option value="Non">Non</option>
                                                    </select> */}
                                                    <div className="column-selector position-relative">
                                                        <button
                                                            style={{
                                                                width: "auto",
                                                                border: "1px solid #000",
                                                                borderRadius: "5px",
                                                                backgroundColor: "transparent",
                                                                padding: "5px 10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                            }}
                                                            className="text-dark"
                                                            onClick={() =>
                                                                setShowColumnSelector((prev) => !prev)
                                                            }
                                                        >
                                                            Visibilité
                                                            <FaChevronDown className="ms-2" size={12} />
                                                        </button>

                                                        {showColumnSelector && (
                                                            <div
                                                                className="column-options bg-white p-3"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    minWidth: "250px",
                                                                    border: "1px solid #ddd",
                                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                                    borderRadius: "4px",
                                                                    zIndex: 1000,
                                                                    marginTop: "5px",
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                    // Style personnalisé pour la scrollbar
                                                                    scrollbarWidth: "thin",
                                                                    scrollbarColor: "#ddd #f8f9fa",
                                                                }}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <strong>Sélection des colonnes</strong>
                                                                    <button
                                                                        className="btn btn-sm btn-link p-0"
                                                                        onClick={() => setShowColumnSelector(false)}
                                                                    >
                                                                        <FaTimes />
                                                                    </button>
                                                                </div>

                                                                <div className="overflow-auto">
                                                                    {Object.entries(columnLabels).map(
                                                                        ([columnKey, label]) => (
                                                                            <div
                                                                                key={columnKey}
                                                                                className="form-check mb-2"
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`column-${columnKey}`}
                                                                                    checked={
                                                                                        visibleColumns[columnKey] || false
                                                                                    }
                                                                                    onChange={() => {
                                                                                        setVisibleColumns((prev) => ({
                                                                                            ...prev,
                                                                                            [columnKey]: !prev[columnKey],
                                                                                        }));
                                                                                    }}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label ms-2"
                                                                                    htmlFor={`column-${columnKey}`}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    {label}
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>

                                                                <div className="d-flex justify-content-between mt-2">
                                                                    <button
                                                                        className="btn btn-sm btn-outline-primary mr-2"
                                                                        onClick={() => {
                                                                            setVisibleColumns(
                                                                                Object.keys(visibleColumns).reduce(
                                                                                    (acc, key) => {
                                                                                        acc[key] = true;
                                                                                        return acc;
                                                                                    },
                                                                                    {}
                                                                                )
                                                                            );
                                                                        }}
                                                                    >
                                                                        Tout sélectionner
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        onClick={() => {
                                                                            setVisibleColumns(
                                                                                Object.keys(visibleColumns).reduce(
                                                                                    (acc, key) => {
                                                                                        acc[key] = false;
                                                                                        return acc;
                                                                                    },
                                                                                    {}
                                                                                )
                                                                            );
                                                                        }}
                                                                    >
                                                                        Tout désélectionner
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                </div>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control mr-2"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="table-" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    className="i-checks"
                                                                    checked={selectedUserIds.length > 0 && selectedUserIds.length === currentUsers.length}
                                                                    onChange={handleSelectAll}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            </th>
                                                            {visibleColumns?.nom_prenom && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom et Prénoms {sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Email && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('email')}>Email {sortConfig.key === 'email'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Email_pro && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('email_pro')}>Email professionnel{sortConfig.key === 'email_pro'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Telephone && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('tel')}>Téléphone {sortConfig.key === 'tel'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Diplome && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('diplome')}>Diplôme {sortConfig.key === 'diplome'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Profession && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('profession')}>Profession {sortConfig.key === 'profession'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.type_financement && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('type_financement')}>Type de financement {sortConfig.key === 'type_financement'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.nom_organisation && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('nom_organisation')}>Organisation {sortConfig.key === 'nom_organisation'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.email_corporate && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('email_corporate')}>Email corporate {sortConfig.key === 'email_corporate'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Statut && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('statut')}>Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Inscription && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('date_insc')}>Inscription {sortConfig.key === 'date_insc'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Derniere_connexion && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('date_der_con')}>Dernière connexion {sortConfig.key === 'date_der_con'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Attestation && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('attestation')}>Attestation {sortConfig.key === 'attestation'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.Certification && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('certification')}>Certification {sortConfig.key === 'certification'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.a_des_acces && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('a_des_acces')}>Accès {sortConfig.key === 'a_des_acces'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            {visibleColumns?.specialites && (
                                                                <th className='text-secondary text-center d-none d-md-table-cell' onClick={() => handleSort('specialites')}>Spécialités {sortConfig.key === 'specialites'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            )}
                                                            <th className='text-secondary text-center' style={{ minWidth: '120px' }}>Actions</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {isLoading ? (
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : currentUsers.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={Object.keys(visibleColumns || {}).length + 2} className="text-center py-4">
                                                                    <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                                                                        <h5>Aucune donnée disponible</h5>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            currentUsers.map((user) => (
                                                                <tr
                                                                    key={user.id}
                                                                    onClick={(e) => handleUserSelect(user, e)}
                                                                    className={`bg-white ${selectedUserIds.includes(user.id) ? 'bg-success text-white' : ''}`}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="i-checks"
                                                                            name="input[]"
                                                                            checked={selectedUserIds.includes(user.id)}
                                                                            onChange={() => handleCheckboxChange(user.id)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                    </td>
                                                                    {visibleColumns?.nom_prenom && (
                                                                        <td>
                                                                            <div className="d-flex align-items-center">
                                                                                <span>{user.nom} {user.prenoms}</span>
                                                                                {user.online && (
                                                                                    <span
                                                                                        className="ml-2"
                                                                                        style={{
                                                                                            display: 'inline-block',
                                                                                            width: '10px',
                                                                                            height: '10px',
                                                                                            borderRadius: '50%',
                                                                                            backgroundColor: '#28a745',
                                                                                            boxShadow: '0 0 2px rgba(0,0,0,0.2)'
                                                                                        }}
                                                                                        title="En ligne"
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                            <div className='lesInfos'>
                                                                                <small>Email : {user.email}</small><br />
                                                                                <small>Téléphone : {user.tel}</small><br />
                                                                                <small>Profession : {user.profession}</small><br />
                                                                                <small>Diplome : {user.diplome}</small><br />
                                                                                <small>Attestation : {user.attestation}</small><br />
                                                                                <small>Certification : {user.certification}</small><br />
                                                                                <small>Statut : {user.statut}</small>
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                    {visibleColumns?.Email && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.email}</td>
                                                                    )}
                                                                    {visibleColumns?.Email_pro && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.email_pro}</td>
                                                                    )}
                                                                    {visibleColumns?.Telephone && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.tel}</td>
                                                                    )}
                                                                    {visibleColumns?.Diplome && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.diplome}</td>
                                                                    )}
                                                                    {visibleColumns?.Profession && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.profession}</td>
                                                                    )}
                                                                    {visibleColumns?.type_financement && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.type_financement}</td>
                                                                    )}
                                                                    {visibleColumns?.nom_organisation && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.nom_organisation}</td>
                                                                    )}
                                                                    {visibleColumns?.email_corporate && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.email_corporate}</td>
                                                                    )}
                                                                    {visibleColumns?.Statut && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.statut}</td>
                                                                    )}
                                                                    {visibleColumns?.Inscription && (
                                                                        <td className="d-none d-md-table-cell text-center">{new Date(user?.date_insc).toLocaleDateString()}</td>
                                                                    )}
                                                                    {visibleColumns?.Derniere_connexion && (
                                                                        <td className="d-none d-md-table-cell text-center">{user?.date_der_con && new Date(user?.date_der_con).toLocaleDateString()}</td>
                                                                    )}
                                                                    {visibleColumns?.Attestation && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.attestation}</td>
                                                                    )}
                                                                    {visibleColumns?.Certification && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.certification}</td>
                                                                    )}
                                                                    {visibleColumns?.a_des_acces && (
                                                                        <td className="d-none d-md-table-cell text-center">{user.a_des_acces}</td>
                                                                    )}
                                                                    {visibleColumns?.specialites && (
                                                                        <td className="d-none d-md-table-cell">
                                                                            {user.specialites && user.specialites.length > 0 ? (
                                                                                <div className="d-flex flex-wrap gap-1">
                                                                                    {user.specialites.map((spec, idx) => (
                                                                                        <span
                                                                                            key={idx}
                                                                                            className="badge bg-info me-1 mb-1"
                                                                                            style={{ fontSize: '10px', cursor: 'pointer' }}
                                                                                            title={spec.tag?.join(', ') || ''}
                                                                                        >
                                                                                            {spec.titre}
                                                                                        </span>
                                                                                    ))}
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-muted">Aucune spécialité</span>
                                                                            )}
                                                                        </td>
                                                                    )}
                                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle variant="light" size="sm" className="bg-transparent border-0">
                                                                                <FaEllipsisV />
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        // Sélectionner l'utilisateur et ouvrir le modal de modification
                                                                                        setSelectedUser(user);
                                                                                        setSelectedUserIds([user.id]);
                                                                                        setShowModalProfil(true);
                                                                                    }}
                                                                                >
                                                                                    <FaEdit className="mr-2 text-primary" />
                                                                                    Modifier

                                                                                    <ModalProfilUtilisateur
                                                                                        show={showModalProfil}
                                                                                        onHide={() => setShowModalProfil(false)}
                                                                                        user_id={selectedUser?.id}
                                                                                        onUpdate={handleProfilUpdate}
                                                                                    />
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        // Sélectionner l'utilisateur et ouvrir le modal d'importation
                                                                                        setSelectedUser(user);
                                                                                        setSelectedUserIds([user.id]);
                                                                                        setShowImportModal(true);
                                                                                    }}
                                                                                >
                                                                                    <FaGraduationCap className="mr-2 text-success" />
                                                                                    Attester
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item
                                                                                    onClick={async () => {
                                                                                        // Sélectionner l'utilisateur et prévisualiser
                                                                                        setSelectedUser(user);
                                                                                        setSelectedUserIds([user.id]);
                                                                                        // Attendre que l'état soit mis à jour avant d'appeler la prévisualisation
                                                                                        setTimeout(() => {
                                                                                            handlePrevisualisation();
                                                                                        }, 50);
                                                                                    }}
                                                                                    disabled={user.attestation !== 'Oui'}
                                                                                >
                                                                                    <FaEye className="mr-2 text-info" />
                                                                                    Visualiser
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        // Sélectionner l'utilisateur et ouvrir le modal de certification
                                                                                        setSelectedUser(user);
                                                                                        setSelectedUserIds([user.id]);
                                                                                        setShowCertificationModal(true);
                                                                                    }}
                                                                                >
                                                                                    <FaMedal className="mr-2 text-warning" />
                                                                                    Certifier
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        setSelectedUser(user);
                                                                                        setSelectedUserIds([user.id]);
                                                                                        handleOpenSpecialiteModal(user);
                                                                                    }}
                                                                                >
                                                                                    <FaCertificate className="mr-2 text-info" />
                                                                                    Spécialités
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item
                                                                                    onClick={() => openClearDataModal(user)}
                                                                                    className="text-danger"
                                                                                >
                                                                                    <FaAdjust className="mr-2 text-danger" />
                                                                                    Reset
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstUser + 1} à ${Math.min(indexOfLastUser, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_utilisateur;
